import { render } from "./ProgramBenefits.vue?vue&type=template&id=05fc00f3&scoped=true"
import script from "./ProgramBenefits.vue?vue&type=script&lang=js"
export * from "./ProgramBenefits.vue?vue&type=script&lang=js"

import "./ProgramBenefits.vue?vue&type=style&index=0&id=05fc00f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fc00f3"]])

export default __exports__